// splide custom element
class SplideSlider extends HTMLElement {
  constructor() {
    super();
    // debugger;
    this.options = JSON.parse(this.querySelector('script#splide-options').textContent) || {};
    this.mobilePerpage = this.options.mobilePerpage || 1;
    this.desktopPerpage = this.options.desktopPerpage || 5;
    this.pagination = this.options.pagination || false;
    this.autoplay = this.options.autoplay || false;
    this.interval = this.options.interval || 3000;
    this.type = this.options.type || 'slide';
    this.init();
  }

  init() {
    const splide = new Splide(this, {
        type: this.type,
        pagination: this.pagination,
        arrows: false,
        perPage: this.mobilePerpage,
        perMove: 1,
        focus: "left",
        gap: "1rem",
        mediaQuery: "min",
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplay: this.autoplay,
        interval: this.interval,
        breakpoints: {
          768: {
            perPage: this.desktopPerpage,
          }
        }
    });
    splide.mount();
  }
}

customElements.define('splide-slider', SplideSlider);
